import "./styles.css";
export default function HeroHomePrestataire() {
    return (
        <section className="heroPrestataire">
            <div>
                <h1>Bienvenue sur l'espace Prestataire d'INTERESEAUX</h1>
                <h2>Boostez votre activité avec INTERESEAUX</h2>
                <p>
                    Vous êtes prestataire de services ? Ne perdez plus de temps à chercher des clients : 
                    nous vous connectons directement à ceux qui ont besoin de vous.
                </p>
                <p>
                    Accédez à des milliers d'offres de projets qualifiés, négociez vos tarifs en temps réél via notre systeme de tchat et importer vos devis et facture pour suivre l'évolution de votre chiffre d'affaires.
                </p>
                <p>
                    Que vous soyez micro-entrepreneur, freelance, petite, moyenne ou grande entreprise, 
                    INTERESEAUX est la plateforme idéale pour développer votre business.
                </p>
            </div>
        </section>
    )
}
